import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Table": Table, "@mui/material/TableBody": TableBody, "@mui/material/TableCell": TableCell, "@mui/material/TableContainer": TableContainer, "@mui/material/TableHead": TableHead, "@mui/material/TableRow": TableRow, "@mui/material/Paper": Paper } } });
export default ClientProvider;
